/* Atharn wall mockup — maths, sample room, export, cart */
window.AtharMockupLib = (function () {
'use strict';
function solve(A, b) {
var n = b.length, M = A.map(function (r, i) { return r.concat([b[i]]); });
for (var c = 0; c < n; c++) {
var p = c;
for (var r = c + 1; r < n; r++) if (Math.abs(M[r][c]) > Math.abs(M[p][c])) p = r;
var t = M[c]; M[c] = M[p]; M[p] = t;
var d = M[c][c];
if (Math.abs(d) < 1e-12) return null;
for (r = 0; r < n; r++) {
if (r === c) continue;
var f = M[r][c] / d;
for (var k = c; k <= n; k++) M[r][k] -= f * M[c][k];
}
}
return M.map(function (row, i) { return row[n] / row[i]; });
}
function homography(src, dst) {
var A = [], b = [];
for (var i = 0; i < 4; i++) {
var x = src[i][0], y = src[i][1], u = dst[i][0], v = dst[i][1];
A.push([x, y, 1, 0, 0, 0, -u * x, -u * y]); b.push(u);
A.push([0, 0, 0, x, y, 1, -v * x, -v * y]); b.push(v);
}
var h = solve(A, b);
if (!h) return null;
h.push(1);
return h;
}
function apply(H, x, y) {
var w = H[6] * x + H[7] * y + H[8];
return [(H[0] * x + H[1] * y + H[2]) / w, (H[3] * x + H[4] * y + H[5]) / w];
}
function invert(m) {
var a = m[0], b = m[1], c = m[2], d = m[3], e = m[4], f = m[5], g = m[6], h = m[7], i = m[8];
var A = e * i - f * h, B = -(d * i - f * g), C = d * h - e * g;
var det = a * A + b * B + c * C;
if (Math.abs(det) < 1e-12) return null;
return [A / det, -(b * i - c * h) / det, (b * f - c * e) / det,
B / det, (a * i - c * g) / det, -(a * f - c * d) / det,
C / det, -(a * h - b * g) / det, (a * e - b * d) / det];
}
function cssMatrix(H) {
return 'matrix3d(' + [H[0], H[3], 0, H[6], H[1], H[4], 0, H[7], 0, 0, 1, 0, H[2], H[5], 0, H[8]].join(',') + ')';
}
function orderQuad(pts) {
var cx = 0, cy = 0;
pts.forEach(function (p) { cx += p[0] / 4; cy += p[1] / 4; });
var s = pts.slice().sort(function (a, b) {
return Math.atan2(a[1] - cy, a[0] - cx) - Math.atan2(b[1] - cy, b[0] - cx);
});
var k = 0;
s.forEach(function (p, i) { if (p[0] + p[1] < s[k][0] + s[k][1]) k = i; });
return s.slice(k).concat(s.slice(0, k));
}
function dist(a, b) { return Math.hypot(a[0] - b[0], a[1] - b[1]); }
function drawSampleRoom(c, evening) {
c.width = 1600; c.height = 1100;
var g = c.getContext('2d');
var wall = g.createLinearGradient(0, 0, 0, 900);
wall.addColorStop(0, '#efe8dc'); wall.addColorStop(1, '#e2d8c8');
g.fillStyle = wall; g.fillRect(0, 0, 1600, 900);
var lightG = g.createRadialGradient(300, 150, 50, 300, 150, 900);
lightG.addColorStop(0, 'rgba(255,250,240,.55)'); lightG.addColorStop(1, 'rgba(255,250,240,0)');
g.fillStyle = lightG; g.fillRect(0, 0, 1600, 900);
var floor = g.createLinearGradient(0, 900, 0, 1100);
floor.addColorStop(0, '#b4977a'); floor.addColorStop(1, '#9c7f62');
g.fillStyle = floor; g.fillRect(0, 900, 1600, 200);
g.fillStyle = '#f6f1e8'; g.fillRect(0, 870, 1600, 30);
g.fillStyle = 'rgba(0,0,0,.12)'; g.fillRect(0, 900, 1600, 6);
g.fillStyle = '#d9cbb4'; g.beginPath(); g.ellipse(800, 1010, 620, 70, 0, 0, Math.PI * 2); g.fill();
g.fillStyle = 'rgba(0,0,0,.18)'; g.beginPath(); g.ellipse(800, 905, 470, 22, 0, 0, Math.PI * 2); g.fill();
g.fillStyle = '#8e9886';
roundRect(g, 360, 560, 880, 160, 26); g.fill();
g.fillStyle = '#9aa492';
roundRect(g, 380, 690, 840, 90, 18); g.fill();
g.fillStyle = '#86907e';
roundRect(g, 340, 640, 90, 230, 30); g.fill();
roundRect(g, 1170, 640, 90, 230, 30); g.fill();
g.fillStyle = '#7c8674'; roundRect(g, 380, 770, 840, 90, 14); g.fill();
g.fillStyle = '#5b4636'; g.fillRect(400, 860, 18, 40); g.fillRect(1182, 860, 18, 40);
g.fillStyle = '#d8c7a8'; roundRect(g, 450, 600, 170, 130, 30); g.fill();
g.fillStyle = '#c9a98a'; roundRect(g, 980, 600, 170, 130, 30); g.fill();
g.fillStyle = '#6b5240'; g.fillRect(1320, 740, 150, 18); g.fillRect(1335, 758, 12, 142); g.fillRect(1443, 758, 12, 142);
g.fillStyle = '#efe6d6'; g.beginPath(); g.moveTo(1350, 600); g.lineTo(1440, 600); g.lineTo(1460, 690); g.lineTo(1330, 690); g.closePath(); g.fill();
g.fillStyle = '#4a3a2e'; g.fillRect(1390, 690, 10, 50);
g.fillStyle = '#b9886a'; roundRect(g, 150, 780, 110, 120, 10); g.fill();
g.fillStyle = '#6f7d5f';
for (var i = 0; i < 9; i++) {
g.save(); g.translate(205, 790); g.rotate(-1.2 + i * 0.3);
g.beginPath(); g.ellipse(0, -110, 26, 110, 0, 0, Math.PI * 2); g.fill(); g.restore();
}
if (evening) {
g.globalCompositeOperation = 'multiply'; g.fillStyle = '#685a50'; g.fillRect(0, 0, 1600, 1100);
g.globalCompositeOperation = 'screen';
var lamp = g.createRadialGradient(1395, 640, 10, 1395, 640, 760);
lamp.addColorStop(0, 'rgba(255,190,110,.95)'); lamp.addColorStop(0.35, 'rgba(255,160,80,.35)'); lamp.addColorStop(1, 'rgba(255,150,70,0)');
g.fillStyle = lamp; g.fillRect(0, 0, 1600, 1100);
g.globalCompositeOperation = 'source-over';
g.fillStyle = 'rgba(255,236,200,.95)'; g.beginPath(); g.moveTo(1350, 600); g.lineTo(1440, 600); g.lineTo(1460, 690); g.lineTo(1330, 690); g.closePath(); g.fill();
}
}
function roundRect(g, x, y, w, h, r) {
g.beginPath(); g.moveTo(x + r, y);
g.arcTo(x + w, y, x + w, y + h, r); g.arcTo(x + w, y + h, x, y + h, r);
g.arcTo(x, y + h, x, y, r); g.arcTo(x, y, x + w, y, r); g.closePath();
}
function tri(ctx, img, s0, s1, s2, d0, d1, d2) {
var cx = (d0[0] + d1[0] + d2[0]) / 3, cy = (d0[1] + d1[1] + d2[1]) / 3;
function grow(p) {
var dx = p[0] - cx, dy = p[1] - cy, l = Math.hypot(dx, dy) || 1;
return [p[0] + dx / l * 0.7, p[1] + dy / l * 0.7];
}
var g0 = grow(d0), g1 = grow(d1), g2 = grow(d2);
ctx.save();
ctx.beginPath(); ctx.moveTo(g0[0], g0[1]); ctx.lineTo(g1[0], g1[1]); ctx.lineTo(g2[0], g2[1]); ctx.closePath();
ctx.clip();
var dx1 = s1[0] - s0[0], dy1 = s1[1] - s0[1], dx2 = s2[0] - s0[0], dy2 = s2[1] - s0[1];
var den = dx1 * dy2 - dx2 * dy1;
var X1 = d1[0] - d0[0], Y1 = d1[1] - d0[1], X2 = d2[0] - d0[0], Y2 = d2[1] - d0[1];
var a = (X1 * dy2 - X2 * dy1) / den, c = (X2 * dx1 - X1 * dx2) / den;
var b = (Y1 * dy2 - Y2 * dy1) / den, d = (Y2 * dx1 - Y1 * dx2) / den;
var e = d0[0] - a * s0[0] - c * s0[1], f = d0[1] - b * s0[0] - d * s0[1];
ctx.transform(a, b, c, d, e, f);
ctx.drawImage(img, 0, 0);
ctx.restore();
}
function warp(ctx, src, map, n) {
var sw = src.width, sh = src.height;
for (var i = 0; i < n; i++) for (var j = 0; j < n; j++) {
var u0 = sw * i / n, u1 = sw * (i + 1) / n, v0 = sh * j / n, v1 = sh * (j + 1) / n;
var p00 = map(u0, v0), p10 = map(u1, v0), p01 = map(u0, v1), p11 = map(u1, v1);
tri(ctx, src, [u0, v0], [u1, v0], [u0, v1], p00, p10, p01);
tri(ctx, src, [u1, v1], [u0, v1], [u1, v0], p11, p01, p10);
}
}
function renderExport(o2) {
var photo = o2.photo, S = o2, P = o2.P;
var nw = photo.naturalWidth, nh = photo.naturalHeight;
var sc = Math.min(1, 2400 / Math.max(nw, nh));
var W = Math.round(nw * sc), Hh = Math.round(nh * sc);
var out = document.createElement('canvas'); out.width = W; out.height = Hh;
var ctx = out.getContext('2d');
ctx.drawImage(photo, 0, 0, W, Hh);
var k = W / S.dw;
var He = S.H.slice(); He[0] *= k; He[1] *= k; He[2] *= k; He[3] *= k; He[4] *= k; He[5] *= k;
var fw = o2.fw, fh = o2.fh, R = 2;
var off = document.createElement('canvas'); off.width = Math.round(fw * R); off.height = Math.round(fh * R);
var o = off.getContext('2d');
o.drawImage(o2.obj, 0, 0, off.width, off.height);
if (o2.paint) o2.paint(o, off.width, off.height, P);
var x0 = S.center[0] - fw / 2, y0 = S.center[1] - fh / 2;
var a = apply(He, S.center[0], S.center[1]), b = apply(He, S.center[0] + 10, S.center[1]);
var ppm = dist(a, b) / 10, sx = -P.side * 28, sy = 22;
var sq = [[x0 + sx, y0 + sy], [x0 + fw + sx, y0 + sy], [x0 + fw + sx, y0 + fh + sy], [x0 + sx, y0 + fh + sy]]
.map(function (p) { return apply(He, p[0], p[1]); });
ctx.save();
try { ctx.filter = 'blur(' + Math.max(2, 20 * ppm) + 'px)'; } catch (err) {}
ctx.fillStyle = 'rgba(0,0,0,' + P.dark + ')';
ctx.beginPath(); ctx.moveTo(sq[0][0], sq[0][1]);
for (var i = 1; i < 4; i++) ctx.lineTo(sq[i][0], sq[i][1]);
ctx.closePath(); ctx.fill();
ctx.restore();
warp(ctx, off, function (u, v) { return apply(He, x0 + u / R, y0 + v / R); }, 12);
var fs = Math.round(W * 0.022);
ctx.font = fs + 'px Georgia, "Times New Roman", serif';
ctx.textAlign = 'right'; ctx.textBaseline = 'bottom';
ctx.shadowColor = 'rgba(0,0,0,.35)'; ctx.shadowBlur = fs * 0.4;
ctx.fillStyle = 'rgba(255,255,255,.9)';
ctx.fillText('atharn.com', W - fs, Hh - fs * 0.8);
return out;
}
function routeRoot() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
function addToCart(btn, id) {
btn.disabled = true; btn.textContent = 'Adding…';
fetch(routeRoot() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) })
.then(function (r) { if (!r.ok) throw new Error('cart'); window.location.href = routeRoot() + 'cart'; })
.catch(function () { btn.disabled = false; btn.textContent = 'Try again'; });
}
function save(btn, opts) {
var label = btn.textContent;
btn.disabled = true; btn.textContent = 'Preparing…';
setTimeout(function () {
var canvas;
try { canvas = renderExport(opts); } catch (err) { btn.disabled = false; btn.textContent = label; return; }
try { canvas.toBlob(done, 'image/jpeg', 0.9); } catch (err) { btn.disabled = false; btn.textContent = 'Saving not available'; }
function done(blob) {
btn.disabled = false; btn.textContent = label;
if (!blob) return;
var file = new File([blob], 'atharn-on-my-wall.jpg', { type: 'image/jpeg' });
if (navigator.canShare && navigator.canShare({ files: [file] })) navigator.share({ files: [file], title: 'Atharn', text: opts.text || '' }).catch(function () {});
else { var a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = file.name; document.body.appendChild(a); a.click(); a.remove(); }
}
}, 30);
}
return { addToCart: addToCart, save: save, solve: solve, homography: homography, apply: apply, invert: invert, cssMatrix: cssMatrix, orderQuad: orderQuad, dist: dist, drawSampleRoom: drawSampleRoom, renderExport: renderExport };
})();